import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { SiteActions, SiteActionTypes } from './site.actions';
import { Site } from './site.model';

export interface State extends EntityState<Site> {}

export const adapter: EntityAdapter<Site> = createEntityAdapter<Site>();

export const initialState: State = adapter.getInitialState({});

export function reducer(state = initialState, action: SiteActions): State {
  switch (action.type) {
    case SiteActionTypes.AddSite: {
      return adapter.addOne(action.payload.site, state);
    }

    case SiteActionTypes.UpsertSite: {
      return adapter.upsertOne(action.payload.site, state);
    }

    case SiteActionTypes.AddSites: {
      return adapter.addMany(action.payload.sites, state);
    }

    case SiteActionTypes.UpsertSites: {
      return adapter.upsertMany(action.payload.sites, state);
    }

    case SiteActionTypes.UpdateSite: {
      return adapter.updateOne(action.payload.site, state);
    }

    case SiteActionTypes.UpdateSites: {
      return adapter.updateMany(action.payload.sites, state);
    }

    case SiteActionTypes.DeleteSite: {
      return adapter.removeOne(action.payload.id, state);
    }

    case SiteActionTypes.DeleteSites: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case SiteActionTypes.LoadSites: {
      return adapter.setAll(action.payload.sites, state);
    }

    case SiteActionTypes.ClearSites: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
